import { useState } from 'react';

import SearchFilter from '../components/SearchFilter';
import { ImportLeadContainer, ImportLeadContent, ImportLeadTitle } from './ImportLead.styles';

const ImportLead = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };

  const handleStatusChange = (value) => {
    setStatusFilter(value);
  };

  return (
    <ImportLeadContainer>
      <ImportLeadTitle>Import Lead</ImportLeadTitle>
      <SearchFilter
        onSearchChange={handleSearchChange}
        onStatusChange={handleStatusChange}
        searchPlaceholder="Search imported leads..."
      />
      <ImportLeadContent>{/* TODO: Add your import lead content here */}</ImportLeadContent>
    </ImportLeadContainer>
  );
};

export default ImportLead;
